import axios from 'axios'
import qs from 'qs'
import {MessageBox, Message} from 'element-ui'
import Code from '@/const/codeConst'
import {MyError} from '@/utils/my-error'
import router from '@/router/index'

// 设置基本配置项
const cfg = {
  /**
   * `method` 是创建请求时使用的方法
   * 默认值：get
   */
  // method: 'post',
  /**
   * baseURL将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
   */
  baseURL: process.env.VUE_APP_BASE_API,
  /**
   * ‘transformRequest’允许在请求数据发送到服务器之前对其进行更改，这只适用于请求方法“ PUT”、“ POST”、“ PATCH”和“ DELETE”。
   * 数组中的最后一个函数必须返回一个字符串或一个Buffer、ArrayBuffer、FormData 或 Stream 的实例。可以修改 headers 对象。
   */
  transformRequest: [
    function (data, headers) {
      // 对 data 进行任意转换处理
      if (data instanceof FormData) {
        headers['Content-Type'] = 'multipart/form-data'
      } else {
        data = qs.stringify(data, {arrayFormat: 'brackets'})
      }
      return data
    }
  ],
  /**
   * `transformresponse` 允许在将响应数据传递给 then/catch 之前对其进行更改。
   */
  // transformResponse: [
  //   function (data) {
  //     // 做任何你想转换数据的事情
  //     return data
  //   }
  // ],
  /**
   * `headers` 是要发送的自定义标头。
   */
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  },
  /**
   * URLSearchParams对象举例：
   *   let paramsString = "q=URLUtils.searchParams&topic=api"
   *   let searchParams = new URLSearchParams(paramsString);
   *   for (let p of searchParams) {
   *     console.log(p);
   *     // 结果打印两个json对象
   *     // ["q", "URLUtils.searchParams"]
   *     // ["topic", "api"]
   *   }
   *
   *   `params` 是要随请求发送的 URL 参数。必须是普通对象或 URLSearchParams 对象。
   */
  // params: {
  //   ID: 12345
  // },
  /**
   * `paramsSerializer` 是一个可选函数，负责序列化 `params`。
   * @param {*} params
   * @returns
   */
  // paramsSerializer: function (params) {
  //   return qs.stringify(params, {arrayFormat: 'brackets'})
  // },
  /**
   * `data` 是要作为请求正文发送的数据。仅适用于请求方法 'PUT'、'POST'、'DELETE 和 'PATCH'。
   * 当没有设置 `transformRequest` 时，必须是以下类型之一：
   * - 字符串、普通对象、ArrayBuffer、ArrayBufferView、URLSearchParams
   * - 仅限浏览器：FormData、File、Blob
   * - 仅限Node：Stream、Buffer
   */
  // data: {
  //   firstName: 'Fred'
  // },
  /**
   * `timeout` 指定请求超时前的毫秒数。如果请求时间超过`timeout`，请求将被中止。默认是0
   */
  timeout: 100000,
  /**
   * `withCredentials` 指示是否应使用凭据进行跨站点访问控制请求。默认值:false
   */
  withCredentials: false
  /**
   * `adapter` 允许自定义处理请求，这使得测试更容易。返回一个Promise并提供有效的响应。
   * @param {*} config
   */
  // adapter: function (config) {},
  /**
   * `auth` 表示应该使用 HTTP 基本身份验证，并提供凭据。
   * 这将设置一个 `Authorization` 标头，覆盖您使用 `headers` 设置的任何现有的 `Authorization` 自定义标头。
   * 请注意，只有 HTTP 基本身份验证可通过此参数进行配置。
   * 对于不记名令牌等，请改用“Authorization”自定义标头。
   */
  // auth: {
  // username: 'janedoe',
  // password: 's00pers3cret'
  // },
  /**
   * `responseType` 表示服务器将响应的数据类型，选项为：'arraybuffer', 'document', 'json', 'text', 'stream'
   * 仅限浏览器：'blob'
   * 会对响应结果自动进行转换
   * 默认值:'json'
   */
  // responseType: 'json',
  /**
   * `responseEncoding` 表示用于解码响应的编码（仅限 Node.js）
   * 注意：忽略“stream”或客户端请求的 `responseType`
   * 默认值:'utf8'
   */
  // responseEncoding: 'utf8',
  /**
   * `xsrfCookieName` 是用作 xsrf 令牌值的 cookie 的名称
   * 默认值:'XSRF-TOKEN'
   */
  // xsrfCookieName: 'XSRF-TOKEN',
  /**
   * `xsrfHeaderName` 是携带 xsrf 令牌值的 http 标头的名称
   * 默认值:'X-XSRF-TOKEN'
   */
  // xsrfHeaderName: 'X-XSRF-TOKEN',
  /**
   * `onUploadProgress` 允许处理上传的进度事件
   * 仅限浏览器
   * @param {*} progressEvent
   */
  // onUploadProgress: function (progressEvent) {
  //   // 使用本机进度事件做任何您想做的事情
  // },
  /**
   * `onDownloadProgress` 允许处理下载的进度事件
   * 仅限浏览器
   * @param {*} progressEvent
   */
  // onDownloadProgress: function (progressEvent) {
  //   // 使用本机进度事件做任何您想做的事情
  // },
  /**
   * `maxContentLength` 定义允许的响应内容的最大尺寸
   */
  // maxContentLength: 2000,
  /**
   * `validateStatus` 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。
   * 如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，
   * promise 将被 resolve; 否则，promise 将被 rejecte
   * 默认值：return status >= 200 && status < 300;
   * @param {*} status
   * @returns
   */
  // validateStatus(status) {
  //   // 设置默认的合法的状态
  //   return status >= 200 && status < 300
  // },
  /**
   * `maxRedirects` 定义在 node.js 中 follow 的最大重定向数目
   * 如果设置为0，将不会 follow 任何重定向
   * 默认值：5
   */
  // maxRedirects: 5
  /**
   * `socketPath` defines a UNIX Socket to be used in node.js.
   * e.g. '/var/run/docker.sock' to send requests to the docker daemon.
   * Only either `socketPath` or `proxy` can be specified.
   * If both are specified, `socketPath` is used.
   */
  // socketPath: null,
  /**
   * `httpAgent` 和 `httpsAgent` 分别在 node.js 中用于定义在执行 http 和 https 时使用的自定义代理。允许像这样配置选项：
   * `keepAlive` 默认没有启用
   */
  // httpAgent: new http.Agent({keepAlive: true}),
  // httpsAgent: new https.Agent({keepAlive: true}),
  /**
   * 'proxy' 定义代理服务器的主机名称和端口
   * `auth` 表示 HTTP 基础验证应当用于连接代理，并提供凭据
   * 这将会设置一个 `Proxy-Authorization` 头，覆写掉已有的通过使用 `header` 设置的自定义 `Proxy-Authorization` 头。
   */
  // proxy: {
  //   host: '127.0.0.1',
  //   port: 9000,
  //   auth: {
  //     username: 'mikeymike',
  //     password: 'rapunz3l'
  //   }
  // },
  /**
   * `cancelToken` 指定用于取消请求的 cancel token
   */
  // cancelToken: new CancelToken(function (cancel) {})
}

// 创建axios实例
const service = axios.create(cfg)

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在请求发送之前进行一些处理
    return config
  },
  (error) => {
    // console.log('request请求阶段错误：' + error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  (response) => {
    // 获取接口返回结果
    const res = response.data
    if (res.Code === Code.SUCCESS) {
      const data = res.Data
      return data
    } else if (res.Code === Code.AUTH_RELOGIN) {
      MessageBox('你正在访问的资源需要通过身份认证后才能访问，你当前无权访问', '用户需要登录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        router.push(`/?redirect=${router.currentRoute.path}`)
      })

      return Promise.reject(new MyError(res.Code, res.Tips || 'Error'))
    } else if (res.Code === Code.KEY_PARAMETER_LOSE) {
      MessageBox('关键性参数丢失，需要点击确定按钮进行重新访问', '关键信息缺失', {
        confirmButtonText: '确定',
        cancelButtonText: '取消重新访问',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        router.push(`/?redirect=${router.currentRoute.path}`)
      })
    } else {
      return Promise.reject(new MyError(res.Code, res.Tips || 'Error'))
    }
  },
  (error) => {
    // console.log('response响应阶段错误：' + error)

    if (error.response) {
      const status = error.response.status
      switch (status) {
        // 404
        case Code.NOT_FOUND:
          Message({
            message: '请求地址不正确',
            type: 'error',
            duration: 5 * 1000
          })
          break
        // 500
        case Code.HTTP_EXCEPTION:
          Message({
            message: '请检查服务器或者网络是否正常',
            type: 'error',
            duration: 5 * 1000
          })
          break
        // 503
        case Code.HTTP_CONNECT_TOO_MUCH:
          Message({
            message: '网络请求连接太多',
            type: 'error',
            duration: 5 * 1000
          })
          break
        // 598
        case Code.HTTP_HIGH_FREQUENCY:
          Message({
            message: '网络请求太频繁',
            type: 'error',
            duration: 5 * 1000
          })
          break
        case Code.NO_PERMISSION:
          Message({
            message: '接口请求权限不足',
            type: 'error',
            duration: 5 * 1000
          })
          break
        default:
          return Promise.reject(new MyError(Code.FAILURE, error.message || 'Error'))
      }
    } else {
      const msg = error.message
      if (msg === 'Network Error') {
        return Promise.reject(new MyError(Code.NETWORK_ERROR, '网络故障'))
      } else {
        if (error.config) {
          const baseUrl = error.config.baseURL
          const requestUrl = error.config.url
          const url = requestUrl.replace(baseUrl, '')
          if (url === '/') {
            return null
          } else {
            return Promise.reject(new MyError(Code.NETWORK_ERROR, '网络连接异常或远程服务未开启'))
          }
        }
      }
    }
  }
)

export default service
